import React from "react";
import "./LoaderMini.styles.scss";

const LoaderMini = () => {
  return (
    <div className="loader-mini-container">
      <img
        src={require("@/assets/images/png/logo-mini.png")}
        className="logo-mini"
        alt="load-profil"
      />
      <img
        src={require("@/assets/images/gif/loadmore.gif")}
        className="load-profil"
        alt="load-profil"
      />
      <small> Chargement </small>
    </div>
  );
};

export default LoaderMini;
